/**
 * The angularjs states related to the module OptinsModule.
 */
audienceStates.$inject = ['$stateProvider'];
export function audienceStates($stateProvider) {
    $stateProvider.state('auth.alcmeon.fuse.audience', {
        url: '/audience',
        data: {
            isMarketingMode: true
        },
        views: {
            'container@auth': {
                template: require('src/ajs-app/components/audience/audience-material.html'),
                controller: 'AudienceController'
            }
        }
    });
}